<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div 
    :id="modalId" 
    class="modal in" 
    data-backdrop="static" 
    data-keyboard="false">
    <div class="row-col h-v">
      <div class="row-cell">
        <div class="modal-dialog w-xxxl">
          <div class="modal-content">
            <a 
              data-dismiss="modal" 
              class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
            <div class="modal-header">
              <h5 class="modal-title">{{ label }}</h5>
            </div>
            <div class="modal-body p-lg">

              <div class="col-xs-12">
                <div class="row dropzone-full-preview">
                  <dropzone 
                    ref="dropzone"
                    :id="id" 
                    :param-name="paramName"
                    :url="url" 
                    :accepted-file-types="acceptedFileTypes"
                    :max-number-of-files="maxNumberOfFiles"
                    :auto-process-queue="autoProcessQueue"
                    @vdropzone-sending="onSendingCallback"
                    @vdropzone-success="uploadSuccessCallback"/>
                </div>
              </div>

              <div class="clearfix"/>

            </div>
            <div class="modal-footer">
              <button 
                :disabled="loading" 
                type="button" 
                class="btn dark-white p-x-md" 
                data-dismiss="modal">Cancel</button>
              <button 
                :disabled="loading" 
                class="md-btn md-raised m-b-sm w-xs green" 
                @click="submit">Save</button>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        pkId: {
            type: Number,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        acceptedFileTypes: {
            type: String,
            default: 'image/*',
        },
        maxNumberOfFiles: {
            type: Number,
            default: 1,
        },
        autoProcessQueue: {
            type: Boolean,
            default: false,
        },
        paramName: {
            type: String,
            default: 'media',
        },
        label: {
            type: String,
            default: 'Uplaod File',
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.outlet.addmedia');
        },
        modalId() {
            return 'modal-dropzone-' + this.id;
        },
    },

    methods: {
        submit() {
            this.loading = true;
            if (this.hasFileToUpload() && !this.hasRejectedFile()) {
                this.uploadFile();
            } else {
                this.loading = false;
            }
        },
        onSendingCallback(file, xhr, formData) {
            formData.append('id', this.pkId);
        },
        uploadSuccessCallback(file, response) {
            this.loading = false;
            this.$refs.dropzone.removeAllFiles();
            $('#' + this.modalId).modal('hide');

            this.$emit('uploadSuccess', file, response);
        },
        hasRejectedFile() {
            return this.$refs.dropzone.getRejectedFiles().length > 0;
        },
        hasFileToUpload() {
            let files = this.$refs.dropzone.getAcceptedFiles();
            return !_.isEmpty(files) && files[0].name != '';
        },
        uploadFile() {
            this.$refs.dropzone.processQueue();
        },
        showForm() {
            $('#' + this.modalId).modal('show');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/VueDropzonePopup.vue